import { apiClient } from '@app/lib'
import { type SugarContent } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const useContent = () => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['content'],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarContent>(`/api/content`, { signal })

      return data
    },
    staleTime: ms('1h')
  })
}
